module.exports = __webpack_public_path__ + "41a56f4b8045612e4787b758de21acec.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bg_theater.jpg
 ** module id = 109
 ** module chunks = 0
 **/